import React from "react";
import { Link as RouterLink } from "react-router-dom";
// import Link from "@mui/material/Link";
import { connect, useSelector, useDispatch } from "react-redux";

import withStyles from '@mui/styles/withStyles';

// import { formatNumberToStringMoney } from "../_helpers";

import { PageWithAppDrawer2 } from "../_components/main/PageWithAppDrawer2";
import { utilityActions } from "../_actions";
import { Paper, Grid, Select, TextField, Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
const withWidth = () => (WrappedComponent) => (props) => <WrappedComponent {...props} width="xs" />;

class AdminRackRateDetailsPage extends React.Component {
  constructor(props) {
    super(props);
    const { id: rackRateId } = this.props.match ? this.props.match.params : {};
    this.state = {
      rackRateId,
      reload: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { id: rackRateId } = nextProps.match ? nextProps.match.params : {};
    if (rackRateId !== prevState.rackRateId) {
      return {
        ...prevState,
        rackRateId,
        reload: true,
      };
    }
    return false;
  }

  async componentDidMount() {}

  render() {
    const { rackRateId, reload } = this.state;
    const { classes } = this.props;

    if (reload === true) {
      this.setState({ reload: false }, () => {
        this.componentDidMount();
      });
      return <></>;
    }

    return (
      <PageWithAppDrawer2 pageTitle={`Rack Rate #${rackRateId}`}>
        <RouterLink to="/admin/rackRates">All Rack Rates</RouterLink>
        <Paper className={classes.paper}>
          <RackRateDetails itemId={rackRateId} />
        </Paper>
      </PageWithAppDrawer2>
    );
  }
}

function RackRateDetails(props) {
  const dispatch = useDispatch();
  const item = useSelector((state) => state.utility.rack_rates_item);
  const states = useSelector((state) => state.utility.us_states);
  const clientTypes = useSelector((state) => state.utility.client_types);
  const paymentTypes = useSelector((state) => state.utility.payment_types);
  const chargeTypes = useSelector(
    (state) => state.utility.vehicle_charge_types
  );
  const fields = [
    {
      width: 2,
      title: "Name",
      field: "name",
      type: "string",
    },
    {
      width: 2,
      title: "Charge Amount",
      field: "charge_amount",
      type: "number",
    },
    {
      width: 2,
      title: "Every Vehicle",
      field: "every_vehicle",
      type: "selectEveryVehicle",
    },
    {
      width: 2,
      title: "Bucket",
      field: "bucket_id",
      type: "bucket",
    },

    // {
    //   width: 2,
    //   title: "Charge Type",
    //   field: "charge_type_id",
    //   type: "selectChargeType"
    // }
  ];

  const id = props.itemId;

  React.useEffect(() => {
    // console.log("useEffect item", item);
    // if (item && item.paymenttype === 0) {
    //   dispatch(
    //     utilityActions.updateOneUtilityLocal("rack_rates", {
    //       ["paymentype"]: ""
    //     })
    //   );
    // }
  }, [item]);

  React.useEffect(() => {
    if (states.items.length === 0) {
      dispatch(
        utilityActions.getUtility("us_states", {
          perPage: 1000,
          orders: [
            {
              field: "stateabbreviation",
              direction: "asc",
            },
          ],
        })
      );
    }
    if (clientTypes.items.length === 0) {
      dispatch(
        utilityActions.getUtility("client_types", {
          perPage: 1000,
        })
      );
    }
    if (paymentTypes.items.length === 0) {
      dispatch(
        utilityActions.getUtility("payment_types", {
          perPage: 1000,
        })
      );
    }
    if (chargeTypes.items.length === 0) {
      dispatch(
        utilityActions.getUtility("vehicle_charge_types", {
          perPage: 1000,
        })
      );
    }
  }, []);

  React.useEffect(() => {
    if (id) {
      if (!item) {
        getNewData();
      } else if (Number(item.id) !== Number(id)) {
        getNewData();
      }
    }
  }, [id]);

  const getNewData = () => {
    // console.log("getNewData");
    dispatch(utilityActions.getOneUtility("rack_rates", id, []));
  };

  const updateLocal = (event) => {
    const { name, value } = event.target;
    dispatch(
      utilityActions.updateOneUtilityLocal("rack_rates", { [name]: value })
    );
  };

  const handleSave = () => {
    dispatch(
      utilityActions.updateUtility("rack_rates", item.id, item, () => {
        getNewData();
      })
    );
  };

  return (
    <>
      {item && item.id ? (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={handleSave}>
              Save Changes
            </Button>
          </Grid>
          {fields.map((field, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12} sm={4}>
                {field.title}
              </Grid>
              <Grid item xs={12} sm={8}>
                {field.type === "string" && (
                  <TextField
                    name={field.field}
                    placeholder={field.title}
                    value={item[field.field] || ""}
                    onChange={updateLocal}
                  />
                )}
                {field.type === "number" && (
                  <TextField
                    name={field.field}
                    type="number"
                    placeholder={field.title}
                    value={item[field.field] || ""}
                    onChange={updateLocal}
                    onWheel={(e) => e.target.blur()}
                  />
                )}
                {field.type === "selectEveryVehicle" && (
                  <Select
                    native
                    name={field.field}
                    value={item[field.field] || "2"}
                    onChange={updateLocal}
                    style={{ fontSize: 12 }}
                  >
                    <option value={false}>No</option>
                    <option value={true}>Yes</option>
                  </Select>
                )}
                {field.type === "bucket" && (
                  <Select
                    native
                    name={field.field}
                    value={item[field.field] || false}
                    onChange={updateLocal}
                    style={{ fontSize: 12 }}
                  >
                    <option value={"1"}>STATE</option>
                    <option value={"2"}>DVS</option>
                    <option value={"3"}>OTHER</option>
                  </Select>
                )}
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      ) : (
        <CircularProgress />
      )}
    </>
  );
}

const styles = (theme) => ({
  root: {
    display: "flex",
    fontSize: 12,
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    width: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    width: "100%",
  },
  fixedHeight: {
    height: 240,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },

  Button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});

function mapStateToProps(state) {
  const { authentication, utility, batch } = state;
  const { user } = authentication;
  return {
    user,
    batch,
    utility,
  };
}

const connectedAdminRackRateDetailsPage = connect(mapStateToProps)(
  withWidth()(withStyles(styles)(AdminRackRateDetailsPage))
);
export { connectedAdminRackRateDetailsPage as AdminRackRateDetailsPage };
